import styled from 'styled-components';
import {
  white,
  scarpaGray800,
  scarpaGray500,
  scarpaGray50,
  monserratRegular,
  robotoRegular,
  electricPurple500,
  tomatoCoral500,
  green500,
  btnDisable,
} from '@habitech/shared';

export const AutomationContainer = styled.div`
  border: 1px solid ${btnDisable};
  border-radius: 6px;
  background: ${white};
  overflow: hidden;
`;

export const AutomationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  cursor: pointer;
  user-select: none;
  background: ${scarpaGray50};

  &:hover {
    background: ${btnDisable};
  }

  .left {
    display: flex;
    align-items: center;
    gap: 10px;

    .title {
      font-family: ${monserratRegular};
      font-size: 14px;
      font-weight: 600;
      color: ${scarpaGray800};
    }
  }

  .counters {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`;

const getCounterColor = (variant: 'approved' | 'rejected' | 'pending') => {
  if (variant === 'approved') return green500;
  if (variant === 'rejected') return tomatoCoral500;
  return scarpaGray500;
};

export const Counter = styled.div<{ variant: 'approved' | 'rejected' | 'pending' }>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: ${robotoRegular};
  font-size: 13px;
  font-weight: 500;
  color: ${({ variant }) => getCounterColor(variant)};
`;

export const VariablesList = styled.div`
  border-top: 1px solid ${btnDisable};
`;

export const VariableRow = styled.div`
  border-bottom: 1px solid ${btnDisable};

  &:last-child {
    border-bottom: none;
  }
`;

export const VariableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  cursor: pointer;
  user-select: none;

  &:hover {
    background: ${scarpaGray50};
  }

  .variable-left {
    display: flex;
    align-items: center;
    gap: 10px;

    .chevron {
      font-size: 10px;
      color: ${scarpaGray500};
      transition: transform 0.2s ease;
      &.open {
        transform: rotate(90deg);
      }
    }

    .variable-name {
      font-family: ${robotoRegular};
      font-size: 14px;
      font-weight: 400;
      color: ${scarpaGray800};
    }
  }

  .status-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: ${robotoRegular};
    font-size: 12px;
    font-weight: 500;
    padding: 3px 10px;
    border-radius: 12px;

    &.approved {
      background: ${green500}20;
      color: ${green500};
    }

    &.rejected {
      background: ${tomatoCoral500}20;
      color: ${tomatoCoral500};
    }

    &.pending {
      background: ${scarpaGray500}20;
      color: ${scarpaGray500};
    }
  }
`;

export const ReasonsList = styled.div`
  padding: 4px 24px 12px 52px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CommentItem = styled.div`
  font-family: ${robotoRegular};
  font-size: 13px;
  font-weight: 400;
  font-style: italic;
  color: ${scarpaGray500};
`;

export const ReasonItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${robotoRegular};
  font-size: 13px;
  font-weight: 400;
  color: ${scarpaGray500};

  &::before {
    content: '•';
    color: ${electricPurple500};
    font-size: 16px;
    line-height: 1;
  }
`;
